module.exports = __webpack_public_path__ + "static/media/3.e7474217.jpg";